<template>
    <div>
        <div class="login-wrap">
            <div class="login-heading">
                <v-img :src="`${publicPath}img/login-banner.png`" :contain=true></v-img>
            </div>
            <div class="login-container">
                <div class="login-content">
                    <p class="subtitle dark-color">{{ $t('Views.Login.message') }}</p>
                    <br/>
                    <v-form action="#" @submit.prevent="login">
                        <v-text-field solo v-model="username" class="login-text-input" type="text"
                                      v-bind:placeholder="$t('Views.Login.username-placeholder')"
                                      @keyup.enter="login"></v-text-field>
                        <v-text-field solo v-model="password" class="login-text-input" type="password"
                                      v-bind:placeholder="$t('Views.Login.password-placeholder')"
                                      @keyup.enter="login"></v-text-field>
                        <div class="login-actions">
                            <v-btn block class="mx-0 login-btn font-weight-light"
                                   color="danger" @click="login" :disabled="isLogin">
                                {{ $t('Views.Login.login') }}
                            </v-btn>
                        </div>
                    </v-form>

                    <p class="login-links">
                        <a @click="signup" class="dark-color small-label">{{ $t('Views.Login.register') }}</a>
                        <span class="link-sepa dark-color small-label"></span>
                        <a class="dark-color small-label" @click="forgotPassword">{{ $t('Views.Login.forgot-password') }}</a>
                    </p>

                    <v-dialog></v-dialog>
                    <v-snackbar
                            v-model="snackbar.show"
                            :color="snackbar.color"
                            :timeout="snackbar.timeout"
                            top>
                        {{ snackbar.text }}
                    </v-snackbar>
                </div>

                <div class="login-footer" />
            </div>

            <v-dialog
                    v-model="showForgotModal"
                    width="600">
                <material-forgot-password :service="service" @close-modal="showForgotModal=false"/>
            </v-dialog>

            <v-dialog
                    v-model="showNewPswModal"
                    width="600"
                    persistent>
                <material-reset-password :newPsw="newPassword" @close-modal="showNewPswModal=false"/>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import i18n from '@/i18n'
    import {mapGetters} from 'vuex'
    import httpService from '@/service/httpService'
    import {publicPath} from "../../vue.config";

    export default Vue.extend({
        name: 'login',
        data () {
            return {
                service: 'dashboard',
                username: '',
                password: '',
                newPassword: {},
                showForgotModal: false,
                showNewPswModal: false,
                snackbar: {
                    show: false,
                    color: '',
                    timeout: 6000,
                    text: ''
                },
                isLogin: false,
                defaultLocale: 'it_IT',
                publicPath: publicPath
            }
        },
        methods: {
            login() {
                this.isLogin = true
                this.$store.dispatch('ACTION_LOGIN', {
                    username: this.username,
                    password: this.password
                }).then(() => {
                    this.$router.push({name: 'Search'})
                }).catch((error) => {
                    console.error(error)
                    this.snackbar.text = this.$t('Views.Login.invalid')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                    this.isLogin = false
                })
            },
            forgotPassword() {
                this.showForgotModal = true
            },
            signup() {
                this.$router.push({name: 'Signup'})
            },
            checkUrlParameters() {

                if (this.$route.query.locale) {
                    this.defaultLocale = this.$route.query.locale == 'cz_CZ' ? 'cs_CZ' : this.$route.query.locale

                    this.$store.dispatch("ACTION_SET_LOCALE", this.defaultLocale)
                        .then(() => i18n.locale = this.locale.substr(0, 2))
                        .catch((error) => {
                            console.error('Error during locale update', error);
                    })
                } else {
                    i18n.locale = this.locale.substr(0, 2)
                }
            },
        },
        computed: {
            ...mapGetters(['getProfile', 'getLanguage']),
            locale() {
                if (this.getLanguage) {
                    return this.getLanguage
                }
                return this.defaultLocale
            },
        },
        mounted() {
            this.checkUrlParameters();

            if(this.getProfile) {
                this.$router.push({name: 'Search'})
            }
        },
        created() {
            if (this.$route.query.username && this.$route.query.key) {
                this.showNewPswModal = true
                httpService.post('/users/' + this.$route.query.username + '/reset-password?key=' + this.$route.query.key)
                .then(newPwd => {
                    this.newPassword = {password: newPwd}
                    this.$router.replace({query: {}})
                }).catch((err) => {
                    console.error(err)
                    this.snackbar.text = this.$t('Views.Login.reset-error')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                    this.showNewPswModal = false
                });
            }
        }
    })
</script>

<style lang="scss" scoped>
    @import '../styles/material-dashboard/variables.scss';

    html, body {
        font-family: 'Open Sans', serif;
        font-size: $font-size-default;
        font-weight: 300;
    }

    .hero.is-success {
        background: #F2F6FA;
    }

    .hero .nav, .hero.is-success .nav {
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .dark-color {
        color: #363636;
        font-weight: unset
    }

    .small-label {
        font-size: $font-size-small;
    }

    .avatar {
        margin-top: 80px;
        padding-bottom: 20px;
    }

    @media screen and (max-width: 1599px) {
        .avatar img {
            max-height: 50px;
        }
    }

    @media screen and (min-width: 1025px) {
        .avatar img {
            padding: 5px;
            padding-left: 30px;
            max-height: 90px;
        }
    }

    input {
        font-weight: 300;
    }

    p {
        font-weight: 700;
    }

    p.subtitle {
        text-align: center
    }

    .login-wrap {
        background-color: $white;
    }

    .login-container {
        background-color: $red;
    }

    .login-heading,
    .login-content,
    .login-footer {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        max-width: 520px;
    }

    .login-content {
        background-color: white;
        padding: 50px 50px 30px;
        border-radius: $border-radius-base;
        border: 1px solid $border-radius-base;
    }

    .v-input.login-text-input /deep/ .v-input__slot {
        border-radius: 15px;
        min-height: auto;
    }

    .login-heading {
        padding-top: 15vh;
    }

    .login-footer {
        padding: 30px 50px;

        color: white;
        text-align: center;

        p {
            font-size: $font-size-small;
            font-weight: normal;
        }
    }

    .login-actions {
        padding-top: 30px;
        text-align: center;
    }

    .login-links {
        margin-top: 30px;
        text-align: center;
    }

    .link-sepa {
        font-weight: bold;
        margin-left: 5px;
        margin-right: 5px;

        &:before {
            content: '\00B7';
        }
    }
</style>
